import React from "react";
import "../layout/Spinner.css";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import { Loader } from "semantic-ui-react";
import AthleteCoach from "./AthleteCoach";
import "./AthleteCoachList.css";

const athleteReduxCoachList = "athleteCoachList";
const athleteReduxScoreVerification = "athleteScoreVerification";

const AthleteCoachList = (props) => {
  const athleteCoachList = props.athleteCoachList;
  const athleteScoreVerification = props.athleteScoreVerification;

  if (isLoaded(athleteCoachList) && isLoaded(athleteScoreVerification)) {
    return (
      <div className="AthleteCoachContainerList">
        <AthleteCoach
          athleteCoach={athleteCoachList}
          athlete={props.athlete}
          athleteScores={athleteScoreVerification}
        />
      </div>
    );
  } else {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    athleteCoachList: state.firestore.data.athleteCoachList,
    athleteScoreVerification: state.firestore.data.athleteScoreVerification,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => [
    {
      collection: "athletes",
      doc: props.id,
      subcollections: [{ collection: "profile", doc: "coaches" }],
      storeAs: athleteReduxCoachList,
    },
    {
      collection: "athletes",
      doc: props.id,
      subcollections: [{ collection: "profile", doc: "images" }],
      storeAs: athleteReduxScoreVerification,
    },
  ])
)(AthleteCoachList);
